var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("\n  "+_vm._s(_vm.model.read_by)+" "),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.readAt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }